import { isAnyBuyAndSellCategory, isAnyRealEstateCategory, isCarsTrucks } from '@kijiji/category'
import { ResultsView } from '@kijiji/generated/graphql-types'

/**
 * Generates a RUM (speedcurve) page type for a SRP page based on the category and view type.
 * Only sending for specific categories & views; can be extended as required
 * @param categoryId - The ID of the category.
 * @param isMapView - Whether the view is a map view.
 * @param isSrpGrid - Whether the view is a grid view.
 * @returns page type to be used with LUX.addData('srpPageType', value)
 */
export const generateRumSrpPageType = (categoryId: number, viewType?: ResultsView) => {
  if (isAnyBuyAndSellCategory(categoryId)) {
    return viewType === ResultsView.Grid ? 'Buy & Sell Grid' : 'Buy & Sell List'
  }

  if (isCarsTrucks(categoryId)) {
    return 'Cars & Trucks'
  }

  if (isAnyRealEstateCategory(categoryId)) {
    return viewType === ResultsView.Map ? 'Real Estate Map' : 'Real Estate List'
  }

  // a null value stops LUX.addData() from sending an empty custom dimension
  return null
}
